import { createSlice } from "@reduxjs/toolkit";
import {
  TFilter,
  TFilterData,
  TGeneralFilterBlock,
} from "@/types/filterBlocks/filterBlockTypes";
import {
  defaultCustomInteractionsInputList,
  defaultWalletSliderData,
} from "@/components/mainContent/general/filters/filter/Filter.data";
import { TFiltrationInitialState } from "@/types/redux/filtrationTypes";

const InitialState: TFiltrationInitialState = {
  audienceType: "",
  condition: "and",
  filters: {},
  filterOperations: [],
};

const filtrationSlice = createSlice({
  name: "filtration",
  initialState: InitialState,
  reducers: {
    setAudienceType: (
      state,
      { payload }: { payload: TFiltrationInitialState["audienceType"] }
    ) => {
      state.audienceType = payload;
    },
    clearFiltration: () => {
      return InitialState;
    },
    addOrOperation: (
      state: TFiltrationInitialState,
      { payload }: { payload: string }
    ) => {
      state.filterOperations = [...state.filterOperations, [payload]];
    },
    addAndOperation: (state, { payload }: { payload: string }) => {
      const lastOperation =
        state.filterOperations[state.filterOperations.length - 1];
      state.filterOperations = [
        ...state.filterOperations.slice(0, state.filterOperations.length - 1),
        [...lastOperation, payload],
      ];
    },
    setConditionAction: (
      state,
      { payload }: { payload: TFiltrationInitialState["condition"] }
    ) => {
      state.condition = payload;
    },
    addFilterAction: (
      state,
      { payload }: { payload: { id: string; type: TGeneralFilterBlock } }
    ) => {
      const filter: TFilter = {
        id: payload.id,
        type: payload.type,
        data: {
          chains: [],
          values:
            payload.type === "wallet_wealth"
              ? { values: defaultWalletSliderData }
              : payload.type === "custom_interaction"
              ? defaultCustomInteractionsInputList
              : {},
        },
      };
      state.filters = { ...state.filters, [payload.id]: filter };
    },
    changeFilterDataAction: (
      state,
      {
        payload,
      }: {
        payload: {
          id: string;
          values?: TFilterData["values"];
          chains?: TFilterData["chains"];
        };
      }
    ) => {
      const filter = state.filters[payload.id];
      if (filter) {
        if (payload.values) filter.data.values = payload.values;
        if (payload.chains) filter.data.chains = payload.chains;
      }
      state.filters = { ...state.filters, [payload.id]: filter };
    },
    deleteFilterAction: (state, { payload }: { payload: { id: string } }) => {
      const newFilters = { ...state.filters };
      delete newFilters[payload.id];
      state.filters = newFilters;
      // state.filterOperations.forEach((list, listIndex) => {
      //     const i = list.indexOf(payload.id)
      //     if (i !== -1) {
      //         if (list.length === 1) {
      //             state.filterOperations.splice(listIndex, 1)
      //         } else {
      //             const newList = list.splice(i, 1)
      //             state.filterOperations.splice(listIndex, 0, newList)
      //         }
      //     }
      // })
    },
    resetFilterAction: (state, { payload }: { payload: { id: string } }) => {
      const type = state.filters[payload.id].type;
      state.filters[payload.id].data = {
        chains: [],
        values:
          type === "wallet_wealth"
            ? { values: defaultWalletSliderData }
            : type === "custom_interaction"
            ? []
            : {},
      };
    },
  },
});

export const {
  setAudienceType,
  clearFiltration,
  // addOrOperation,
  // addAndOperation,
  setConditionAction,
  addFilterAction,
  changeFilterDataAction,
  deleteFilterAction,
  resetFilterAction,
} = filtrationSlice.actions;

export default filtrationSlice.reducer;
